import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Branch } from 'src/app/interfaces/branch/branch.interface';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss'],
})
export class BranchesComponent implements OnChanges {
  @Input() branch!: Branch;

  formattedName: string = '';
  formattedAddress: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['branch'] && this.branch) {
      this.formattedName = this.capitalizeEachWord(this.branch.name || '');
      this.formattedAddress = this.capitalizeEachWord(this.branch.address || '');
    }
  }

  capitalizeEachWord(text: string): string {
    return text
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  redirectToMap() {
    if (this.branch?.latitude && this.branch?.longitude) {
      const mapsUrl = `https://www.google.com/maps/dir//'${this.branch.latitude},${this.branch.longitude}'/@${this.branch.latitude},${this.branch.longitude},17z`;
      window.open(mapsUrl, '_blank');
    }
  }
}
